module.exports = __webpack_public_path__ + "static/media/quantities-icon.e91f25b8.svg";